import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logos/ool-logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-521849b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ool-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "textbox-container" }, "@2026 Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "ool-logo",
    width: "75em"
  })
], -1))
const _hoisted_3 = { class: "customer-container" }
const _hoisted_4 = { class: "textbox-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, "v" + _toDisplayString(_ctx.getAppVersion), 1)
    ])
  ]))
}